module.exports = __webpack_public_path__ + "img/help_4.6de442bf.png";